export const TONIC_FEE_DIVISOR = 10_000; // By design
